export enum Errors {
  BACKEND_ERROR_CASE_HAS_SELFADJUST = 'Bad Request: This case already has a selfadjust'
}
